import { KEYS } from 'game/constants/SceneConstants';
import GameSceneBase from './GameSceneBase';
import { GameTimer } from '../../display/ui/games/GameTimer';
import { OnboardingPointer } from '../../display/ui/OnboardingPointer';
import { FONT_BASE } from '../../constants/AppFonts';

const LAYOUTS = [
  {
    spineBG: 'garden',
    items: [
      {
        id: 'bees',
        skin: 'item_bees',
        quality: 'good',
      },
      {
        id: 'trash',
        skin: 'item_trash',
        quality: 'bad',
      },
      {
        id: 'bush',
        skin: 'item_bush',
        quality: 'good',
      },
      {
        id: 'tree',
        skin: 'item_tree',
        quality: 'good',
      },
      {
        id: 'pond',
        skin: 'item_pond',
        quality: 'good',
      },
      {
        id: 'bbq',
        skin: 'item_bbq',
        quality: 'bad',
      },
      {
        id: 'feeder',
        skin: 'item_feeder',
        quality: 'good',
      },
      {
        id: 'sprinkler',
        skin: 'item_sprinkler',
        quality: 'bad',
      },
    ],
  },
  {
    spineBG: 'livingroom',
    items: [
      // {
      //   id: 'window',
      //   skin: 'item_window',
      //   quality: 'bad',
      // },
      {
        id: 'heater',
        skin: 'item_heater',
        quality: 'bad',
      },
      {
        id: 'tv',
        skin: 'item_tv',
        quality: 'bad',
      },
      {
        id: 'fan',
        skin: 'item_fan',
        quality: 'good',
      },
      // {
      //   id: 'door',
      //   skin: 'item_door',
      //   quality: 'bad',
      // },
      {
        id: 'acu',
        skin: 'item_acu',
        quality: 'bad',
      },
    ],
  },
  {
    spineBG: 'kitchen',
    items: [
      {
        id: 'rainCatcher',
        skin: 'item_rain_catcher',
        quality: 'good',
      },
      // {
      //   id: 'washing',
      //   skin: 'item_washing_machine',
      //   quality: 'good',
      // },
      // {
      //   id: 'dishwasher',
      //   skin: 'item_dishwasher',
      //   quality: 'bad',
      // },
      {
        id: 'fridge',
        skin: 'item_fridge',
        quality: 'bad',
      },
      {
        id: 'compost',
        skin: 'item_compost',
        quality: 'good',
      },
    ],
  },
  {
    spineBG: 'bathroom',
    items: [
      {
        id: 'sink',
        skin: 'item_sink',
        quality: 'bad',
      },
      {
        id: 'shower',
        skin: 'item_shower',
        quality: 'good',
      },
      {
        id: 'bath',
        skin: 'item_bath',
        quality: 'bad',
      },
      {
        id: 'soapBits',
        skin: 'item_soap_bits',
        quality: 'good',
      },
      // {
      //   id: 'soapBar',
      //   skin: 'item_soapbar',
      //   quality: 'bad',
      // },
    ],
  },
];

const GAME_TIME_LIMIT = 100000;

export default class EcoExpert extends GameSceneBase {
  constructor() {
    super({ key: KEYS.EcoExpert, active: false });
  }

  create() {
    super.create();
    this.gameRunning = false;
    this.gameTime = GAME_TIME_LIMIT;
    // main bg with each layout
    this.spineBG = new BackgroundLayouts(this, 840, 360, 'eco_expert_game_background');

    // game clock display
    this.gameClock = new GameTimer(this, 1050, 0);
    //  this.gameClock.setTimePercent(0);
    // item reticule display
    this.spineReticule = new ItemReticule(this, 840, 285, 'eco_expert_game_reticule');
    this.spineReticule.visible = false;

    // badge menu bar
    this.badgeMenuBar = this.add
      .image(835, 100, 'eco_expert', 'btn_background')
      .setScale(0.4)
      .setOrigin(0.5);
    this.goodBadge = this.add
      .image(788, 100, 'eco_expert', 'sticker_good_')
      .setScale(0.3)
      .setInteractive({ useHandCursor: true });
    this.goodBadge.id = 'good';
    this.badBadge = this.add
      .image(880, 100, 'eco_expert', 'sticker_bad_')
      .setScale(0.3)
      .setInteractive({ useHandCursor: true });
    this.badBadge.id = 'bad';
    this.input.setDraggable([this.goodBadge, this.badBadge]);

    // target position to drag items too
    this.hitarea = { x: 840, y: 420, radius: 128 };

    this.roundelTextContainer = this.add.container();
    this.roundelTextContainer.setPosition(840, 1000);
    this.roundelTextPanel = this.add.image(0, 0, 'eco_expert', 'roundel_text');
    this.roundelText = this.add
      .text(0, -10, '', {
        font: `24px ${FONT_BASE.COPY}`,
        color: '#000000',
        align: 'center',
        wordWrap: { width: this.roundelTextPanel.width - 20 },
      })
      .setOrigin(0.5);
    this.roundelTextContainer.add([this.roundelTextPanel, this.roundelText]);

    this.onboardingPointer = new OnboardingPointer(this, {
      dragPositions: {
        from: [this.goodBadge, this.badBadge],
        to: [this.hitarea],
      },
    });

    this.setupGame();
  }

  // added a drag toggle so we can enable/disable to prevent user spam
  enableBadges(value) {
    if (value && !this.dragEnabled) {
      this.dragEnabled = true;
      this.input.on('dragstart', this.handleDragStart, this);
      this.input.on('drag', this.handleDrag, this);
      this.input.on('dragend', this.handleDragEnd, this);
    } else if (!value && this.dragEnabled) {
      this.dragEnabled = false;
      this.input.off('dragstart', this.handleDragStart, this);
      this.input.off('drag', this.handleDrag, this);
      this.input.off('dragend', this.handleDragEnd, this);
    }
  }

  // =============================================================================================
  // GAME SETUP
  // =============================================================================================
  setupGame() {
    // reset game properties
    this.gameRunning = false;
    this.gameClock.visible = false;
    this.gameTime = GAME_TIME_LIMIT;
    this.currentLayout = -1;
    this.validPlacement = 0;
    this.invalidPlacement = 0;
    this.layoutItems = [];
    this.draggingBadge = false;
    this.currentItem = false;

    this.startGame();
  }

  showInstruction() {
    super.showInstruction(
      this.game.copy.get('EcoExpert_instruction'),
      this.setupCurrentLayout,
      this
    );
  }

  startGame() {
    this.gameRunning = true;
    // start the game and reveal the clock
    this.gameClock.enter();
    this.gameClock.visible = true;

    // show meenu bar
    this.badgeMenuBar.visible = true;
    this.badBadge.visible = true;
    this.goodBadge.visible = true;
    // enable badges so user can drag them
    this.enableBadges(true);
    // trigger current game layout

    this.startNextlayout();
  }

  restartGame() {
    this.setupGame();
  }

  // =============================================================================================
  // LAYOUTS AND ITEM SPAWN
  // =============================================================================================

  startNextlayout() {
    this.gameRunning = false;
    this.currentLayout++;

    if (!LAYOUTS[this.currentLayout]) {
      this.handleGameEnd();
    } else {
      this.spineBG.showNextLayout(this.setupCurrentLayout, this);
      this.spineBG.showLayout(
        LAYOUTS[this.currentLayout].spineBG,
        this.currentLayout === 0 ? this.showInstruction : this.setupCurrentLayout,
        this
      );
      this.spineBG.on('event', this.handleSpineEvent, this);
    }
  }

  handleSpineEvent(t, e) {
    if (e.data?.name === 'sfx') {
      switch (e.stringValue) {
        case 'page_open':
          this.game.soundController.playSFX('general', 'general_page_open');
          break;
        case 'page_close':
          this.game.soundController.playSFX('general', 'general_page_close');
          break;
        case 'page_popup':
          this.game.soundController.playSFX('general', 'general_popup');
          break;
      }
    }
  }
  setupCurrentLayout() {
    // loop over current layout items and shuffle them to create layout game
    this.layoutItems = LAYOUTS[this.currentLayout].items
      .map((item) => {
        return {
          quality: item.quality,
          skin: item.skin,
          id: item.id,
        };
      })
      .sort(() => Math.random() - 0.5);

    // spawn the first item
    this.spawnNextItem();
    this.gameRunning = true;
  }

  spawnNextItem() {
    // just check our layout items direct
    if (this.layoutItems.length === 0) {
      this.startNextlayout();
    } else {
      // and we just remove from our layout items until we run out
      this.currentItem = this.layoutItems.shift();

      console.log(this.currentItem, this.game.copy.get(`EcoExpert_${this.currentItem.id}`));

      this.spineReticule.visible = true;
      this.spineReticule.setItem(this.currentItem.skin, true);
      this.spineReticule.enter();
      this.onboardingPointer.enable();
      this.roundelText.text = this.game.copy.get(`EcoExpert_${this.currentItem.id}`);
      this.tweens.add({
        targets: this.roundelTextContainer,
        y: 600,
        duration: 150,
      });
    }
  }

  // =============================================================================================
  // DRAG EVENTS
  // =============================================================================================

  handleDragStart(pointer, gameObject) {
    this.setDraggingBadge(gameObject.x, gameObject.y, gameObject.id);
  }

  handleDrag(pointer, gameObject, dragX, dragY) {
    if (this.draggingBadge) {
      this.draggingBadge.x = dragX;
      this.draggingBadge.y = dragY;
    }
  }

  handleDragEnd(pointer, gameObject, dragX, dragY) {
    if (this.draggingBadge) {
      this.validateDroppedbadge(this.draggingBadge);
      this.destroyDraggingBadge();
    }
  }

  setDraggingBadge(x, y, type) {
    this.destroyDraggingBadge();
    this.draggingBadge = this.add.image(x, y, 'eco_expert', `sticker_${type}_`);
    this.draggingBadge.setScale(0.6);
    this.draggingBadge.quality = type;
    return this.draggingBadge;
  }

  destroyDraggingBadge() {
    if (this.draggingBadge) {
      this.draggingBadge.destroy();
      this.draggingBadge = null;
    }
  }

  // =============================================================================================
  // VALIDATION CHECK
  // =============================================================================================

  validateDroppedbadge(droppedBadge) {
    // check if reticule can actually accept a badge
    if (this.spineReticule.canAcceptBadge()) {
      // check if badge is dropped within valid area
      const validPosition =
        Math.abs(droppedBadge.x - this.hitarea.x) < this.hitarea.radius &&
        Math.abs(droppedBadge.y - this.hitarea.y) < this.hitarea.radius;
      // if in valid area
      if (validPosition) {
        // check quality match and incenerement player scores

        //Sound plays based on badge quality
        // this.game.soundController.playSFX(
        //   'ecoexpert',
        //   droppedBadge.quality === 'good' ? 'expert_tick' : 'expert_cross'
        // );
        if (droppedBadge.quality === this.currentItem.quality) {
          //Sound plays based on whether placement is correct
          this.game.soundController.playSFX('ecoexpert', 'expert_tick');
          this.validPlacement++;
        } else {
          this.game.soundController.playSFX('ecoexpert', 'expert_cross');
          this.invalidPlacement++;
        }

        // set the bade display on the reticule and play it out
        this.onboardingPointer.disable();
        this.spineReticule.setBadge(droppedBadge.quality);
        this.spineReticule.exit(this.spawnNextItem, this);
        this.tweens.add({
          targets: this.roundelTextContainer,
          y: 1000,
          duration: 150,
        });
      }
    }
  }

  // =============================================================================================
  // UPDATE METHOD
  // =============================================================================================

  update(t, delta) {
    if (!this.gameRunning) return;

    this.gameTime -= delta;
    this.gameClock.setTimePercent(this.gameTime / GAME_TIME_LIMIT);

    if (this.gameTime <= 0) this.handleGameEnd();
  }

  // =============================================================================================
  // FINISHING GAME
  // =============================================================================================

  handleGameEnd() {
    this.tweens.add({
      targets: this.roundelTextContainer,
      y: 1000,
      duration: 150,
    });

    this.gameRunning = false;
    this.game.soundController.stopAllSFX();
    // clear badge in game user in dragging it
    this.destroyDraggingBadge();
    this.onboardingPointer.disable();
    this.spineReticule.exit();
    this.gameClock.exit();
    this.badgeMenuBar.visible = false;
    this.badBadge.visible = false;
    this.goodBadge.visible = false;
    this.enableBadges(false);

    const totalLayoutItems = Object.keys(LAYOUTS).reduce(
      (i, key) => i + LAYOUTS[key].items.length,
      0
    );
    const percent = this.validPlacement / totalLayoutItems;

    let stars;

    if (this.gameTime > 0) {
      if (percent > 0 && percent <= 0.25) {
        stars = 0;
      } else if (percent > 0.25 && percent <= 0.5) {
        stars = 1;
      } else if (percent > 0.5 && percent <= 0.75) {
        stars = 2;
      } else if (percent > 0.75 && percent <= 1) {
        stars = 3;
      }
      this.closeGame(stars >= 2, stars);
    } else {
      if (percent > 0 && percent <= 0.5) {
        stars = 0;
      } else if (this.gameTime <= 0.5 && this.gameTime <= 1) {
        stars = 1;
      }

      this.closeGame(false, stars);
    }
  }

  closeGame(didwin, stars) {
    this.game.soundController.stopMusic('music');
    this.game.soundController.playSFX('general', didwin ? 'general_success' : 'general_fail', {
      delay: 1.2,
    });
    this.game.soundController.playSFX('ecoexpert', didwin ? 'expert_success' : 'expert_fail', {
      delay: 2.2,
    });
    this.spineBG.playEnding(didwin, () => this.showEndGameScreen(didwin, stars), this);
  }

  shutdown() {
    this.game.soundController.stopAllSFX();
    super.shutdown();
    this.enableBadges(false);
    this.game.unloadGame(KEYS.EcoExpert);
  }
}

// =============================================================================================
// SCENE BACKGROUND LAYOUTS CLASS
// =============================================================================================

class BackgroundLayouts extends SpinePlugin.SpineGameObject {
  constructor(scene, x, y, spineid) {
    super(scene, scene.spine, x, y, spineid);
    scene.add.existing(this);
  }

  enter(onComplete, onCompleteScope) {
    this.clearListeners();
    this.timeScale = 1;
    this.eventCallback = { onComplete, onCompleteScope };
    this.once('event', this.handleEvent, this);
    //this.play('game');
  }

  handleEvent(t, e) {
    if (e.data.name === 'play') {
      this.timeScale = 0;
      if (this.eventCallback) {
        this.eventCallback.onComplete.apply(this.eventCallback.onCompleteScope);
        this.eventCallback = null;
      }
    }
  }

  clearListeners() {
    this.removeAllListeners('complete');
    this.removeAllListeners('event');
  }

  showNextLayout(onComplete, onCompleteScope) {
    this.clearListeners();
    this.timeScale = 1;
    this.eventCallback = { onComplete, onCompleteScope };
    this.on('event', this.handleEvent, this);
  }

  showLayout(layout, onComplete, onCompleteScope) {
    this.timeScale = 1;
    this.eventCallback = { onComplete, onCompleteScope };
    this.on('event', this.handleEvent, this);
    if (!this._layout) {
      this.play(layout);
    } else {
      this.once('complete', () => {
        this.play(layout);
      });
    }
    this._layout = layout;
  }

  playEnding(win, onComplete, onCompleteScope) {
    this._layout = false;
    this.clearListeners();
    this.once(
      'complete',
      () => {
        this.once('complete', onComplete, onCompleteScope);
        this.play(win ? 'win' : 'lose');
      },
      this
    );
    this.timeScale = 1;
  }
}

// =============================================================================================
// ITEM RETICLE CLASS
// =============================================================================================

class ItemReticule extends SpinePlugin.SpineGameObject {
  constructor(scene, x, y, spineid) {
    super(scene, scene.spine, x, y, spineid);
    scene.add.existing(this);

    this._defaultSkin = this.findSkin('default');
    this._combinationSkin = new scene.spine.plugin.Skin('combination');

    this._currentItem = false;
    this._currentBadge = false;
    this._acceptBadge = false;

    this.updateSkin();
  }

  canAcceptBadge() {
    return this._acceptBadge;
  }

  enter(onComplete, onCompleteScope) {
    this.removeAllListeners('complete');

    this.once('complete', () => {
      this._acceptBadge = true;
      if (onComplete) onComplete.apply(onCompleteScope);
    });
    this.play('in');
  }

  exit(onComplete, onCompleteScope) {
    this._acceptBadge = false;
    this.removeAllListeners('complete');
    if (onComplete) this.once('complete', onComplete, onCompleteScope);
    this.play('out', false, true);
  }

  setItem(item, removeBadge) {
    this._currentItem = item;
    if (removeBadge) this._currentBadge = false;
    this.updateSkin();
  }

  setBadge(badge) {
    if (!this._acceptBadge) return false;
    this._currentBadge = badge ? 'choice_' + badge : false;
    this.updateSkin();
  }

  updateSkin() {
    this._combinationSkin.clear();
    this._combinationSkin.addSkin(this._defaultSkin);
    const itemSkin = this._currentItem ? this.findSkin(this._currentItem) : false;
    if (itemSkin) this._combinationSkin.addSkin(itemSkin);
    const badgeSkin = this._currentBadge ? this.findSkin(this._currentBadge) : false;
    if (badgeSkin) this._combinationSkin.addSkin(badgeSkin);
    this.setSkin(this._combinationSkin);
  }
}
